import type { IconButtonProps } from '@mui/material'
import { IconButton, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import DeleteIcon from '@mui/icons-material/Delete'
import { memo, type ReactNode } from 'react'

type Props = IconButtonProps & {
  tooltip?: ReactNode
}

const DeleteIconButton = ({ tooltip, ...props }: Props) => {
  const { t } = useTranslation()
  return (
    <Tooltip title={tooltip || t('common.delete')}>
      <IconButton color="error" {...props}>
        <DeleteIcon />
      </IconButton>
    </Tooltip>
  )
}

export default memo(DeleteIconButton)
